import type { SxProps } from '@coolblue-development/freddy';
import { freddyTheme } from '@coolblue-development/freddy';

import { comparisonColumnStyles } from '../ComparisonColumn';

export const propertyColumnStyles: SxProps = {
  ...comparisonColumnStyles,
  width: 'var(--comparison-column-width)',

  '&:first-of-type, &:first-of-type a': {
    paddingLeft: 0
  },

  '&:first-of-type': {
    display: 'none'
  },

  [freddyTheme.breakpoint.minWidth('md')]: {
    '&:first-of-type': {
      paddingRight: freddyTheme.spacing[300],
      wordBreak: 'break-word'
    }
  },

  [freddyTheme.breakpoint.minWidth('lg')]: {
    '&:first-of-type': {
      display: 'flex',
      position: 'sticky',
      left: 0,
      backgroundColor: freddyTheme.color.background.base
    }
  },

  [freddyTheme.breakpoint.maxWidth('md')]: {
    '&:first-of-type:not(:last-of-type)': {
      display: 'none'
    }
  }
};

export const mobileStickyHeaderStyles: SxProps = {
  marginTop: freddyTheme.spacing[300],
  display: 'table',
  position: 'sticky',
  left: 0
};

export const propertyRowStyles: SxProps = {
  borderBottom: `${freddyTheme.borderWidth[25]} solid ${freddyTheme.color.border.interactiveBase}`,

  '&:has(.property-row:not(.all-values-are-same):last-of-type)': {
    borderBottom: 'none'
  },

  '&.has-explanation': {
    cursor: 'pointer',

    [freddyTheme.breakpoint.maxWidth('md')]: {
      strong: {
        color: freddyTheme.color.font.additional,
        borderBottom: `${freddyTheme.borderWidth[25]} dashed ${freddyTheme.color.font.additional}`
      }
    }
  }
};

export const propertyIconButtonContainerStyles: SxProps = {
  width: '2.4rem',

  [`${freddyTheme.breakpoint.minWidth('md')} && ${freddyTheme.breakpoint.maxWidth('lg')}`]: {
    paddingLeft: 0
  }
};
